import { getTimeFromDate, dateFormatter } from "@services/utils";
import React from "react";
import Image from "next/image";

type MatchAVenirProps = {
  adversaire: string;
  adversaireLogo?: string;
  competition: string;
  dateMatch: string;
  infoSup?: string;
  bestOf?: string;
  equipeDeathrow: any;
  lien?: string;
};

const MatchAVenir: React.FC<MatchAVenirProps> = ({ adversaire, adversaireLogo, equipeDeathrow, competition, bestOf, dateMatch, infoSup, lien }) => {
  return (
    <div id="match-a-venir" className="card flex flex-col justify-center !bg-blackAccent">
      <div id="match-a-venir-header" className="mb-4 flex flex-col">
        <div id="resultat-card-header-infos" className="flex flex-row items-center justify-between">
          <div id="resultat-card-header-info-texte" className="flex flex-col">
            <h4 className="text-sm font-semibold uppercase line-clamp-1 md:text-xl">{competition}</h4>
            <p className="text-ellipsis text-xs font-light text-whiteAccent/70 line-clamp-1 md:text-sm">
              BO{bestOf} {infoSup && `| ${infoSup}`}
            </p>
          </div>
          {lien && (
            <a
              id="resultat-card-header-info-stream-button"
              href={lien}
              rel="noreferrer noopener"
              target={"_blank"}
              className=" button mt-2 bg-darkAccent text-center text-sm font-medium uppercase text-whiteAccent/90"
            >
              stream
            </a>
          )}
        </div>
      </div>
      <div id="match-a-venir-body" className="flex flex-col-reverse justify-evenly space-y-4 md:flex-row ">
        <div id="match-a-venir-body-container" className="flex flex-1 flex-row items-center justify-evenly">
          <div id="resultat-card-body-container-deathrow" className="flex flex-1 flex-col items-center justify-center py-2">
            <div id="resultat-card-body-container-deathrow-logo" className="flex flex-row items-center space-x-2">
              <div className="relative h-12 w-12 object-contain">
                <Image placeholder="blur" blurDataURL={"/dw-logo.png"} layout="fill" alt={`Logo DeathroW`} src="/dw-logo.png" />
              </div>
            </div>
            <div id="resultat-card-body-container-deathrow-equipe" className={`text-xs line-clamp-1`}>
              {equipeDeathrow}
            </div>
          </div>
          <span className="font-bold tracking-widest">VS</span>
          <div id="resultat-card-body-container-adversaire" className="flex flex-1 flex-col items-center justify-center">
            <div id="resultat-card-body-container-adversaire-logo" className="flex flex-row items-center space-x-2">
              {adversaireLogo && (
                <div className="relative h-12 w-12 object-contain">
                  <Image placeholder="blur" blurDataURL={adversaireLogo} layout="fill" alt={`Logo de ${adversaire}`} src={adversaireLogo} />
                </div>
              )}
            </div>
            <div id="resultat-card-body-container-adversaire-equipe" className={`text-xs line-clamp-1 `}>
              {adversaire}
            </div>
          </div>
        </div>

        <div
          id="match-a-venir-body-date-time"
          className="flex flex-row justify-around border-b-2 border-whiteAccent/30 py-2 font-bold tracking-widest text-redAccent md:flex-col md:border-b-0"
        >
          <span className="flex-1 text-center md:flex-none">{dateFormatter(dateMatch)}</span>
          <span className="flex flex-1 flex-row items-center justify-center space-x-2 md:flex-none">
            <span className="hidden h-1 flex-1 rounded bg-redAccent md:flex"></span>
            <span>{getTimeFromDate(dateMatch)}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default MatchAVenir;
